import React from 'react';

// Make hatTarget 'ref="hatTarget"'
// Add '.fill' to all body elements
// Add '.fill--face' to nose

class HeadHOC extends React.Component {
	componentDidMount() {
		this.props.getHatTargetCoords(this.refs.hatTarget);
	}
}

export default class Heads extends HeadHOC {
	render() {
		return (
			<g>
				<circle ref="hatTarget" cx="236.90427" cy="250.6335" />
				<g className="face">
					<path className="tongue" fill="#FC5959" d="M230.61247,342.19141c0,3.33945,3.36089,6.04663,7.50673,6.04663
						c4.14586,0,7.50674-2.70718,7.50674-6.04663v-9.25476h-15.01347V342.19141z" />
					<path className="fill fill--dark" fill="#EFEFEF" d="M238.1192,318.85925c12.40154,0,22.14075,7.6553,22.45496,17.08688
						c0.33173,9.95657-8.14845,18.2236-22.45496,12.98276c-14.30649,5.24084-22.78665-3.02618-22.45496-12.98276
						C215.97847,326.51456,225.71768,318.85925,238.1192,318.85925z" />
					<path className="fill--face" d="M245.41101,329.70923c0-0.03384-0.00722-0.06638-0.00853-0.09988
						c-0.00133-0.01633-0.00241-0.03241-0.00415-0.04874c-0.13356-2.31052-3.33676-4.16071-7.27913-4.16071
						c-3.94753,0-7.15431,1.85498-7.27991,4.17007c-0.00168,0.01608-0.00288,0.03229-0.00414,0.04849
						c-0.00108,0.03049-0.00775,0.06003-0.00775,0.09076h0.00691c-0.01532,0.48917,0.14485,0.99353,0.53345,1.4451l4.50221,4.2478
						c1.10489,1.28397,3.35802,1.29068,4.47348,0.01321l4.53848-4.27423c0.38048-0.44855,0.53711-0.94766,0.52203-1.43188H245.41101z" />
					<g className="eyebrow eyebrow--left">
						<ellipse className="fill fill--dark" transform="matrix(0.74435 -0.66779 0.66779 0.74435 -144.46913 216.79323)" fill="#EFEFEF" cx="210.91142" cy="297.08267" rx="7.12136" ry="5.91489" />
					</g>
					<g className="eyebrow eyebrow--right">
						<ellipse className="fill fill--dark" transform="matrix(0.66779 -0.74435 0.74435 0.66779 -133.13193 295.87057)" fill="#EFEFEF" cx="264.89709" cy="297.08267" rx="5.91489" ry="7.12136" />
					</g>
				</g>
			</g>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Global/Pet/Seal/Heads.js